import { Grid } from 'ui';
import { ReactElement } from 'react';
import { Typography } from 'omakase';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { useResponsiveCallToActionStyles } from './responsiveCallToActionStyles';
import clsx from 'clsx';

interface Props {
  title: ReactElement | string;
  isTitle: boolean;
  bodyText: ReactElement | string;
  action: JSX.Element;
  imageUrl: string;
  altText: string;
  imageSize?: 'regular' | 'large' | 'small';
}

const ResponsiveCallToAction = ({
  title,
  isTitle,
  bodyText,
  action,
  imageUrl,
  altText,
  imageSize = 'regular',
}: Props) => {
  const classes = useResponsiveCallToActionStyles();

  let imageSizeStyle = '';
  switch (imageSize) {
    case 'large':
      imageSizeStyle = classes.callToActionImageStyleLarge;
      break;
    case 'small':
      imageSizeStyle = classes.callToActionImageStyleSmall;
      break;
    case 'regular':
      break;
    default:
      assertNever(imageSize);
  }

  const imageStyles = clsx(classes.callToActionImageStyle, imageSizeStyle);

  return (
    <Grid className={classes.callToActionRootStyle} container spacing={2}>
      <Grid item container xs={12} sm={5} md={6} direction="column" justifyContent="center">
        <img className={imageStyles} src={imageUrl} alt={altText} />
      </Grid>
      <Grid item container xs={12} sm={7} md={6} direction="column" justifyContent="center">
        <div className={classes.callToActionHeaderStyle}>
          {typeof title === 'string' ? (
            <Typography component={isTitle ? 'h1' : 'h2'} variant="heading02">
              {title}
            </Typography>
          ) : (
            <>{title}</>
          )}
        </div>
        <div className={classes.callToActionBodyStyle}>
          {typeof bodyText === 'string' && (
            <Typography component="p" variant="body02">
              {bodyText}
            </Typography>
          )}
          {typeof bodyText !== 'string' && bodyText}
        </div>
        <div>{action}</div>
      </Grid>
    </Grid>
  );
};

export default ResponsiveCallToAction;
